import { render, staticRenderFns } from "./BackupRepoDetailsDialog.vue?vue&type=template&id=63317590&"
import script from "./BackupRepoDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./BackupRepoDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports